import { withStyles } from '@material-ui/core';

import Tags from './component';
import styles from './styles';

export default withStyles(styles)(Tags);
